/* SHARED VARS */
var firstrun = true,
    liveEffects = ['fade','scale'],
    liveEasing = 'smooth',
    liveSpeed = 500,
    touch = false,
    list = false,
    clickEv = 'click';

/* SANDBOX */
function mixSandBox(){
  
  // INSTANTIATE MIXITUP ON SANDBOX
  
  if($('#sandBox').length)
  $('#sandBox').mixitup({
    buttonEvent: clickEv,
    onMixStart: function(config){
      
      // PAUSE LOGO ON SANDBOX ACTIVITY
      if(typeof timer != 'undefined'){
        clearInterval(timer);
      };
      if(typeof counter != 'undefined'){
        clearInterval(counter);
      };
      
      // UPDATE EFFECTS LIST
      config.effects = liveEffects;
      
      // UPDATE EASING
      config.easing = liveEasing;
      
      // UPDATE SPEED
      config.transitionSpeed = liveSpeed;
      
      return config;
    },
    onMixEnd: function(config){
      
      // ADD LIST STYING
      var wait = setTimeout(function(){
        if(config.layoutMode == 'list'){
          list = true;
        };
        
        sortSandBox();
        
        // rebind add to cart event
        $('.add-to-cart').bind( clickEv, addToCart );
        
      },100);
    }
  });
}

function sortSandBox(){
  var listSB = $('#sandBox .item');
  listSB.removeClass('first');
  $("#sandBox .item:nth-child(5n)").addClass('first');
}

var isMobile = {
    Android: function() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function() {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
};

/* Fucntion get width browser */
function getWidthBrowser() {
	var myWidth;

	if( typeof( window.innerWidth ) == 'number' ) { 
		//Non-IE 
		myWidth = window.innerWidth;
		//myHeight = window.innerHeight; 
	} 
	else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { 
		//IE 6+ in 'standards compliant mode' 
		myWidth = document.documentElement.clientWidth; 
		//myHeight = document.documentElement.clientHeight; 
	} 
	else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { 
		//IE 4 compatible 
		myWidth = document.body.clientWidth; 
		//myHeight = document.body.clientHeight; 
	}
	
	return myWidth;
}

/* Function: Refresh Zoom */
function alwaysUpdateZoom(){
  if(touch == false){
    
    if($('.elevatezoom').length){
      
      var zoomImage = $('.elevatezoom .img-zoom');

      zoomImage.elevateZoom({
        gallery:'gallery_main', 
        galleryActiveClass: 'active', 
        zoomType: 'window',
        cursor: 'pointer',
        zoomWindowFadeIn: 300,
        zoomWindowFadeOut: 300,
        scrollZoom: true,
        easing : true,
        loadingIcon: '//cdn.shopify.com/s/files/1/0434/6617/t/5/assets/loader.gif?v=147071982126738704471400178975'
      });
      
      
        //pass the images to Fancybox
        $(".elevatezoom .img-zoom").bind("click", function(e) {  
          var ez =   $('.elevatezoom .img-zoom').data('elevateZoom');	
          $.fancybox(ez.getGalleryList(),{
            closeBtn  : true,
            helpers : {
              buttons	: {}
            }
          });
          return false;
        });
      
    }
    
  }
       // is touch
       else{
         
       }
}
    
// handles scroll-to-top button
function handleScrollToTopButton() {
  
  function totop_button(a) {
    var b = $("#scroll-to-top");
    b.removeClass("off on");
    if (a == "on") { b.addClass("on") } else { b.addClass("off") }
  }
  
  $(window).scroll(function() {
    var b = $(this).scrollTop();
    var c = $(this).height();
    if (b > 0) { 
      var d = b + c / 2;
    } 
    else { 
      var d = 1 ;
    }
    
    if (d < 1e3 && d < c) { 
      totop_button("off");
    } 
    else {
      
      totop_button("on"); 
    }
  });
  
  $("#scroll-to-top").click(function (e) {
    e.preventDefault();
    $('body,html').animate({scrollTop:0},800,'swing');
  });
}
      
/* Function update scroll product thumbs */
function updateScrollThumbs(){
  if($('#gallery_main').length){
    
    

    $('#product-image').on(clickEv, '.image-thumb', function() {

      var $this = $(this);
      var background = $('.product-image .main-image .main-image-bg');
      var parent = $this.parents('.product-image-wrapper');
      var src_original = $this.attr('data-image-zoom');
      var src_display = $this.attr('data-image');
      
      background.show();
      
      parent.find('.image-thumb').removeClass('active');
      $this.addClass('active');
      
      parent.find('.main-image').find('img').attr('data-zoom-image', src_original);
      parent.find('.main-image').find('img').attr('src', src_display).load(function() {
        background.hide();
      });
      
      return false;
    });
  }
}
    
/* Function update scroll product thumbs */
function updateScrollThumbsQS(){
  if($('#gallery_main_qs').length){
    
    

    $('#quick-shop-image').on(clickEv, '.image-thumb', function() {

      var $this = $(this);
      var background = $('.product-image .main-image .main-image-bg');
      var parent = $this.parents('.product-image-wrapper');
      var src_original = $this.attr('data-image-zoom');
      var src_display = $this.attr('data-image');
      
      background.show();
      
      parent.find('.image-thumb').removeClass('active');
      $this.addClass('active');
      
      parent.find('.main-image').find('img').attr('data-zoom-image', src_original);
      parent.find('.main-image').find('img').attr('src', src_display).load(function() {
        background.hide();
      });
      
      return false;
    });
  }
}

// handles Animate
function dataAnimate(){
  $('[data-animate]').each(function(){
    
    var $toAnimateElement = $(this);
    
    var toAnimateDelay = $(this).attr('data-delay');
    
    var toAnimateDelayTime = 0;
    
    if( toAnimateDelay ) { toAnimateDelayTime = Number( toAnimateDelay ); } else { toAnimateDelayTime = 200; }
    
    if( !$toAnimateElement.hasClass('animated') ) {
      
      $toAnimateElement.addClass('not-animated');
      
      var elementAnimation = $toAnimateElement.attr('data-animate');
      
      $toAnimateElement.appear(function () {
        
        setTimeout(function() {
          $toAnimateElement.removeClass('not-animated').addClass( elementAnimation + ' animated');
        }, toAnimateDelayTime);
        
      },{accX: 0, accY: -100},'easeInCubic');
      
    }
    
  });
}
    
function handleFocus(){
  $(".form-focus input").focus(function() {
    $(this).parents('.form-focus').addClass('focus');
  }).blur(function() {
    $(this).parents('.form-focus').removeClass('focus');
  });
}
    
function handleBoxLogin(){
  $("#loginBox input").focus(function() {
    $(this).parents('#loginBox').addClass('focus');
  }).blur(function() {
    $(this).parents('#loginBox').removeClass('focus');
  });
}
    
function handleBoxSearch(){
  $('#header-search input').focus(function() {
    $(this).parent().addClass('focus');
  });
  $('#header-search input').blur(function() {
    $(this).parent().removeClass('focus');
  });
}
    

function specialBackground(){
  var w_width = getWidthBrowser();
  var w_content = $('#content-wrapper').outerWidth();
  var s_width = ((w_width - w_content) / 2 ) + 1;
  
  
  
  
}
   
function callbackSearchMobile(){
  var button = $('.is-mobile .is-mobile-search i');
  var form = $('.is-mobile .is-mobile-search .search-form');
  button.mouseup(function(search) {
    form.show();
  });
  form.mouseup(function() { 
    return false;
  });
  $(this).mouseup(function(search) {
    if(!($(search.target).parent('.is-mobile .is-mobile-search').length > 0)) {
      form.hide();
    }
  });  
}

$(window).resize(function() {
  
  specialBackground();
  
  if(touch == true || getWidthBrowser() < 1024){
    $('#navigation').removeClass('on');
  }
});


$(window).scroll(function() {
  // Listener for header
  var scrollTop = $(this).scrollTop();
  var heightHeader = $('#top').outerHeight() + $('#navigation').outerHeight();

  if(touch == false && getWidthBrowser() >= 1024){
    if(scrollTop > heightHeader){
      $('#navigation').addClass('on');
    }
    else{
      $('#navigation').removeClass('on');
    }
  }
});
      
$(window).load(function() {
  
  $('.overlay-content').hide();
  specialBackground();
});

jQuery(document).ready(function($) {
  
  /* DETECT PLATFORM */
  $.support.touch = 'ontouchend' in document;
  
  if ($.support.touch) {
    touch = true;
    $('body').removeClass('.notouch').addClass('touch');
    clickEv = 'touchstart';
  }
  else{
    $('body').removeClass('.touch').addClass('notouch');
    if (navigator.appVersion.indexOf("Mac")!=-1){
      if (navigator.userAgent.indexOf("Safari") > -1){
        $('body').addClass('macos');
      }
      else if (navigator.userAgent.indexOf("Chrome") > -1){
        $('body').addClass('macos-chrome');
      }
        else if (navigator.userAgent.indexOf("Mozilla") > -1){
          $('body').addClass('macos-mozilla');
        }
    }
  };
  
  /* Handle Animate */
  if(touch == false){
    dataAnimate();
  }
  
  /* Focus search input */
  handleBoxSearch();
  
  /* Display search in mobile */
  callbackSearchMobile();
  
  /* Cloud Zoom in Product page */
  alwaysUpdateZoom();
  
  
  
  
  handleScrollToTopButton();
  
  // Create contact map
  /* GMap */
  if(jQuery().gMap){
    $('#contact_map').gMap({
      zoom: 17,
      scrollwheel: false,
      maptype: 'TERRAIN',
      markers:[
        {
          address: '',
          html: '_address'
        }
      ]
    });
  }
  
  $('.dropdown-menu').on(clickEv, function (e) {
    e.stopPropagation();
  });
  $('.dropdown-menu').on('click', function (e) {
    e.stopPropagation();
  });
  $('.btn-navbar').on('click', function() {
    return true;
  });
   
   
  $(".dropdown-toggle").parent().hover(function (){
     if(touch == false && getWidthBrowser() > 768 ){
       $(this).find('.dropdown-menu').stop(true, true).slideDown(300);
     }
  }, function (){
     if(touch == false && getWidthBrowser() > 768 ){
       $(this).find('.dropdown-menu').hide();
     }
  });
  $('.dropdown-link').on('click', function() {
     if(touch == false && getWidthBrowser() > 768 ){
       var href = $(this).attr('href');
       window.location = href;
     }
  });
  handleBoxLogin();
   
   
  $('#collection_tags').on('change', function() {
    window.location = $(this).val();
  });
  
  if($("img.unveil").length){
    $("img.unveil").unveil(300);
  }
  
  
  /* Quantity */
  $('.quantity-wrapper').on(clickEv, '.qty-up', function() {
    var $this = $(this);
    
    var qty = $this.data('src');
    $(qty).val(parseInt($(qty).val()) + 1);
  });
  $('.quantity-wrapper').on(clickEv, '.qty-down', function() {
    var $this = $(this);
    
    var qty = $this.data('src');
    
    if(parseInt($(qty).val()) > 1)
    	$(qty).val(parseInt($(qty).val()) - 1);
  });

  
  /* Tooltip */
  if(clickEv !== 'touchstart'){
    $('.btooltip').tooltip();
  }
  
  
  /* Add class first, last in sidebar */
  $('.sidebar').children('.row-fluid').first().addClass('first');
  $('.sidebar').children('.row-fluid').last().addClass('last');
  

  /* INSTANTIATE SANDBOX */
  //mixSandBox();
  
  /* Sort by */
  $('#sortForm li.sort').click(function(){  // add event any time the sort box changes
    
    var button = $('#sortButton');
    var box = $('#sortBox');
    
    $('#sortButton .name').html($(this).html());
    
    button.removeClass('active');
    box.hide();
  });
  
  sortbyPopup();
  function sortbyPopup(){
    var warper = $('#sortButtonWarper');
    var button = $('#sortButton');
    var box = $('#sortBox');
    var form = $('#sortBox #sortForm');
    warper.click(function(sort) {
      box.toggle();
      button.toggleClass('active');
    });
    form.mouseup(function() { 
      return false;
    });
    $(this).mouseup(function(sort) {
      if(!($(sort.target).parent('#sortButton').length > 0)) {
        button.removeClass('active');
        box.hide();
      }
    });
  }
  
  /* GRID/LIST */
  $('#goList').on(clickEv, function(e){
    $(this).parent().find('li').removeClass('active');
    $(this).addClass('active');
    
    $('#sandBox .element').addClass('full_width');
    $('#sandBox .element .row-left').addClass('span3');
    $('#sandBox .element .row-right').addClass('span9');
    
    if(clickEv == 'touchstart'){
      $(this).click();
      return true;
    }
  });
  
  $('#goGrid').on(clickEv, function(e){
    $(this).parent().find('li').removeClass('active');
    $(this).addClass('active');
    
    $('#sandBox .element').removeClass('full_width');
    $('#sandBox .element .row-left').removeClass('span3');
    $('#sandBox .element .row-right').removeClass('span9');
    
    if(clickEv == 'touchstart'){
      $(this).click();
      return true;
    }
  });
});